import type * as React from 'react';

/**
 * EAA-2063: "the whole question must fit the screen". A page image keeps its aspect ratio,
 * never grows past its own size or its column, and is capped to part of the viewport so the
 * question below it stays on screen. A layout may raise the cap by setting the CSS variable
 * (the speaking side-by-side layout's picture column does).
 */
export const IMAGE_MAX_HEIGHT_VAR = '--ach-image-max-h';
export const DEFAULT_IMAGE_MAX_HEIGHT = 'min(40vh, 360px)';
export const SPLIT_COLUMN_IMAGE_MAX_HEIGHT = 'min(55vh, 560px)';

export type ImageAlignment = 'left' | 'center' | 'right';

const ALIGN_MARGIN: Record<ImageAlignment, string> = {
    left: '0 auto 0 0',
    center: '0 auto',
    right: '0 0 0 auto',
};

/** Style for the `<img>` of an image block (the figure's size class still sets its width cap). */
export function imageElementImgStyle(alignment: ImageAlignment = 'center'): React.CSSProperties {
    return {
        display: 'block',
        // `auto` (not 100%) so a small picture is never upscaled.
        width: 'auto',
        height: 'auto',
        maxWidth: '100%',
        maxHeight: `var(${IMAGE_MAX_HEIGHT_VAR}, ${DEFAULT_IMAGE_MAX_HEIGHT})`,
        objectFit: 'contain',
        margin: ALIGN_MARGIN[alignment] ?? ALIGN_MARGIN.center,
    };
}

/** For a container whose images may be taller (e.g. a side-by-side picture column). */
export function imageMaxHeightVars(maxHeight: string): React.CSSProperties {
    return { [IMAGE_MAX_HEIGHT_VAR]: maxHeight } as React.CSSProperties;
}
